import { AppContext } from 'src/components/app-context';
import React, { CSSProperties, memo, useContext } from 'react';

interface CdnImageProps {
  name: string | number;
  height?: number;
  width?: number;
  logoUrl?: string | null;
  alt?: string;
}

const makeImageUrl = (cdnUrl: string, name: string | number) =>
  `${cdnUrl}g/ftg_logos/store_${name}.png`;

export const CdnImage: React.FC<CdnImageProps> = memo(
  ({ name, alt, logoUrl, width, height }) => {
    const {
      market: { imageCdnUrl = '' },
    } = useContext(AppContext);

    const imageUrl = logoUrl ?? makeImageUrl(imageCdnUrl, name);

    const styles: CSSProperties = {};

    if (height) {
      styles.height = height;
    }

    return (
      // @ts-expect-error picture is typed as HTMLElement which does not have alt attribute
      <picture alt={alt}>
        {/* Safari fallback */}
        <source srcSet={imageUrl} type="image/png" />
        {/* IE fallback */}
        <img src={imageUrl} alt={alt} width={width} style={styles} />
      </picture>
    );
  }
);
